import { Segmented } from 'antd';
import moment from 'moment';

import { TRangeEdge } from '../hooks/useDateRangeSelection';

import style from '../dateRangeCalendar.module.scss';

const MINUTE_OPTIONS = [0, 10, 20, 30, 40, 50].map((minutes) => ({
    value: minutes,
    label: String(minutes).padStart(2, '0'),
}));

const EDGE_TITLE: Record<TRangeEdge, string> = {
    start: 'Начало',
    end: 'Окончание',
};

type TProps = {
    edge: TRangeEdge;
    value: moment.Moment;
    onChange: (minutes: number) => void;
};

/** Панель минут для выбранной ячейки: шаг 10 минут, по умолчанию «00» */
export const MinutePicker = ({ edge, value, onChange }: TProps) => (
    <div className={style['minute-picker']}>
        <span>
            {EDGE_TITLE[edge]}: <b>{value.format('HH:mm')}</b>
        </span>
        <Segmented
            size="small"
            options={MINUTE_OPTIONS}
            value={value.minutes()}
            onChange={(minutes) => onChange(minutes)}
        />
    </div>
);
